import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import GetDomains from '../../GetDomains'
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Select from 'react-select';
import Loader from 'react-loader-spinner';

class Dsm extends Component {
    constructor() {
        super();
        this.state = {
            setContentEditable: true,
            inEditState: false,
            noSlot: false,
            data: [{
                name: '', description: ''
            }],
            pageNum: null,
            domainId: null,
            handlerId: null,
            editedId: "-1",
            hideDeletePopup: false,
            disableAdd: false,
            intentId: null,
            selectedValue: null,
            showLoader: false
        };
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";

        this.domains = [];

        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

        this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deletedDsmApi(this.state.propsId)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
    }

    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            thisController.fetchDomain();
            thisController.fetchDsmData();
            thisController.fetchSlotDataApi();
        }, 300);
        document.addEventListener("projectChanged", function (event) {
            thisController.domains = [];
            thisController.projectId = event.projectId;
            thisController.fetchDomain();
            thisController.fetchDsmData(event.projectId);
            thisController.fetchSlotDataApi();
        });
    }

    fetchDomain = () => {
        var dsmController = this;
        var domainList = GetDomains();
        var isDomainIdInCurrentProject = false;
        if (domainList !== undefined) {
            for (var i = 0; i < domainList.length; i++) {
                if (localStorage.getItem("dsmDomainId") !== undefined &&
                    domainList[i]["domainId"] === localStorage.getItem("dsmDomainId")) {
                    isDomainIdInCurrentProject = true;
                }
                dsmController.domains.push({ "value": domainList[i]["domainId"], "label": domainList[i]["domain"] });
            }

            if (dsmController.props.location.state !== undefined) {
                if (isDomainIdInCurrentProject) {
                    dsmController.state.selectedValue = localStorage.getItem("dsmDomainName");
                    dsmController.state.domainId = localStorage.getItem("dsmDomainId");
                } else {
                    dsmController.state.selectedValue = dsmController.domains[0].label;
                    dsmController.state.domainId = domainList[0]["domainId"];
                }
            } else {
                dsmController.state.selectedValue = dsmController.domains[0].label;
                dsmController.state.domainId = domainList[0]["domainId"];
            }
            dsmController.setState(dsmController.state);
        }
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchDsmData = (projectId) => {
        this.state.setContentEditable = true;
        this.setState(this.state);
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var domainId = this.state.domainId;
        let data = {
            projectId: projectId,
            domainId: domainId
        }
        let dsmController = this;
        $.ajax({
            url: "/api/dsm",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    dsmController.state.inEditState = false;

                    dsmController.setState({
                        data: res['result'],
                        showLoader: true,
                        disableAdd: false
                    });
                } else {
                    dsmController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    handleChange = (e) => {
        this.state.selectedValue = e.label;
        this.state.domainId = e.value;
        localStorage.setItem("dsmDomainName", e.label);
        localStorage.setItem("dsmDomainId", e.value);
        this.state.disableAdd = false;
        this.setState(this.state);
        this.fetchDsmData();
    }

    addRow = (data) => {
        this.setState({ setContentEditable: false })

        var dsmController = this;
        if (dsmController.state.pageNum != 0) {
            dsmController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            name: '', description: ''
        });
        this.setState({
            disableAdd: true
        })
    }

    validateCells(name, description) {
        if ((name == "" || description == "")) {
            this.notifyEmptyFields();
            return false;
        } else {
            return true;
        }

    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });
    }

    //add new DSM 
    saveCell(props, e) {
        this.setState(this.state);
        var domainId = this.state.domainId;
        props.original.name = document.getElementById("name" + props.index).innerText.trim();
        props.original.description = document.getElementById("description" + props.index).innerText.trim();
        this.state.editedId = "-1";
        this.state.setContentEditable = true;
        this.setState(this.state);

        this.setState(this.state);
        if (this.validateCells(props.original.name, props.original.description)) {
            var updatedData = {
                name: props.original.name,
                description: props.original.description,
                projectId: localStorage.getItem("currentProjectId"),
                domainId: domainId
            };
            var dsmController = this;
            $.ajax({
                url: "/api/dsm",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(updatedData),
                processData: false,
                success: function (res) {
                    dsmController.setState(dsmController.state);
                    if (res.success === true) {
                        dsmController.setState({ disableAdd: false })
                        dsmController.fetchDsmData();
                        dsmController.notifyDsmAddedSuccess();
                    } else {
                        dsmController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    notifyDsmAddedSuccess() {
        toast.dismiss();
        toast(<b><img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Dsm Added Successfully</b>, {
            position: "top-center",
        });
    }
    //Update cell
    updateDsmApi = (props, e) => {
        var domainId = document.getElementById("domain" + props.index).value;
        props.original.name = document.getElementById("name" + props.index).innerText.trim();
        props.original.description = document.getElementById("description" + props.index).innerText.trim();
        let dsmController = this;
        this.state.setContentEditable = true;
        this.setState(this.state);

        if (this.validateCells(props.original.name, props.original.description)) {
            var data = {
                id: props.original.id,
                name: props.original.name,
                description: props.original.description,
                projectId: localStorage.getItem("currentProjectId"),
                domainId: domainId
            };
            $.ajax({
                url: "/api/dsm",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {

                        dsmController.state.editedId = "-1";
                        dsmController.fetchDsmData();
                        dsmController.notifyDsmUpdatedSuccess();
                    } else {
                        dsmController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }


    notifyDsmUpdatedSuccess() {
        toast.dismiss();
        toast(<b><img src="./assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Dsm Updated Successfully</b>, {
            position: "top-center",
        });
    }

    editCell = (props, e) => {
        this.state.setContentEditable = false;
        this.setState(this.state);
        this.state.editedId = props.original.id;
        this.state.inEditState = true;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    deletedDsmApi = (id) => {
        let dsmController = this;
        $.ajax({
            url: "/api/dsm/" + id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    dsmController.setState({ hideDeletePopup: false });
                    dsmController.fetchDsmData();
                    dsmController.notifyDsmDeleteSuccess();
                } else {
                    dsmController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyDsmDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Dsm Deleted Successfully</b>, {
            position: "top-center"
        });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.state.disableAdd = false;
        this.fetchDsmData()
    }

    fetchMappingDetailsApi = (handlerId) => {
        var DsmController = this;
        var isMappedToIntent = false;
        $.ajax({
            url: "/api/dsm-mapping",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId"),
                "handlerId": handlerId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.result !== null) {
                    isMappedToIntent = true;
                    DsmController.state.intentId = res.result.intentId;
                    DsmController.setState(DsmController.state);
                } else {
                    isMappedToIntent = false;
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
        return isMappedToIntent;
    }
    fetchIntentDetailsApi = (handlerId) => {
        var DsmController = this;
        var isSlotsPresent = false;
        $.ajax({
            url: "/api/dsm-mapping-intent-check",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId"),
                "handlerId": handlerId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                //Check intent map
                if (res.result !== null) {

                    if (res.result == "Failed") {
                        //  isMappedToIntent = false;
                        DsmController.state.noSlot = true;
                        DsmController.setState(DsmController.state);
                        DsmController.notifyNoSlot();
                    } else if (res.result == "no slots") {
                        DsmController.state.noSlot = true;
                        DsmController.setState(DsmController.state);
                        DsmController.notifyNotMapped();
                    }
                    else {
                        isSlotsPresent = true;
                        DsmController.state.intentId = res.result.intentId;
                        DsmController.setState(DsmController.state);
                    }
                } else {
                    isSlotsPresent = false;

                }

            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
        return isSlotsPresent;
    }

    mapToIntend = (props, e) => {
        let dsmController = this;
        let isMappedToIntent = dsmController.fetchMappingDetailsApi(props.original.id);
        if (isMappedToIntent) {
            this.props.history.push({
                pathname: '/projectmgmt/handler-mappig-details',
                state: {
                    domainId: dsmController.state.domainId,
                    handlerId: props.original.id,
                    handlerName: props.original.name,
                    previousCompPath: "dsm"
                }
            });
        } else {
            this.props.history.push({
                pathname: '/projectmgmt/map-handler-and-intent',
                state: {
                    domainId: dsmController.state.domainId,
                    handlerId: props.original.id,
                    previousCompPath: "dsm"
                }
            });
        }
        this.setState(this.setState)
    }

    routeToTransition = (props, e) => {
        let routeToTransitionController = this;
        let isMappedToIntent = routeToTransitionController.fetchMappingDetailsApi(props.original.id);
        if (isMappedToIntent) {
            routeToTransitionController.props.history.replace({
                pathname: "/projectmgmt/transition",
                state: {
                    intentId: routeToTransitionController.state.intentId,
                    dstId: props.original.id,
                    skillName: props.original.name
                }
            });
            localStorage.setItem("intentId", routeToTransitionController.state.intentId);
        } else {
            routeToTransitionController.notifyMapToIntendWarning();
        }
    }
    fetchSlotDataApi = () => {
        var fetchController = this;
        $.ajax({
            url: "/api/slots",
            async: false,
            method: 'GET',
            data: {
                intentId: localStorage.getItem("intentId")

            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length == 0) {
                        fetchController.state.noSlot = true;
                        fetchController.setState(fetchController.state);
                    }
                } else {
                    fetchController.setState({
                        successResp: false
                    })
                    fetchController.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }
    notifyNoSlot() {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please add slots inside the mapped intent</b>, {
            position: "top-center"
        });
    }
    notifyNotMapped() {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please map the intent</b>, {
            position: "top-center"
        });
    }
    notifyMapToIntendWarning() {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Mapping to an intent has to be done before configuring Transitions</b>, {
            position: "top-center"
        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    handleTableDomainChange = (props, e) => {
        props.original.domainId = e.target.value;
        //    this.state.domainId  = e.target.value;
        props.original.name = document.getElementById("name" + props.index).innerText;
        props.original.description = document.getElementById("description" + props.index).innerText;
        this.setState(this.state);
    }
    render() {
        const { data } = this.state
        const selectedOption = this.state.selectedValue;

        const columns = [
            {
                Header: <b>Name</b>,
                accessor: 'name',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"name" + props.index}
                >{props.original.name}</div>
                )
            },
            {
                Header: <b>Description</b>,
                accessor: 'description',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"description" + props.index}
                >{props.original.description}</div>)
            },
            {
                Header: <b>Category</b>,
                accessor: 'category',
                sortable: false,
                width: 200,
                show: this.state.inEditState,
                Cell: props => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <select type="select-multiple" className="input-group form-control select2 "
                            value={props.original.domainId} id={"domain" + props.index}
                            onChange={(e) => this.handleTableDomainChange(props, e)}
                            style={{ background: 'white', border: 'none' }}
                            disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}>
                            {this.domains.map(domain => (
                                <option key={domain.value} value={domain.value} >
                                    {domain.label}
                                </option>
                            ))}
                        </select>
                    </div>)
            },
            {
                width: 300,
                Header: <b>Action/Configuration</b>,
                accessor: "action",
                sortable: false,
                Cell: props => (
                    <div id="action">
                        <div style={{ marginTop: "-6px" }}>
                            {/* Map to Intent Button */}
                            <p>  <button className="btn2 table-action-button"
                                onClick={(e) => {
                                    this.mapToIntend(props, e)
                                }}
                                hidden={(props.original.id == undefined) ? true : false}>
                                Map to Intent</button> <b />
                                {/* Transitions Button */}
                                <button className="btn2 table-action-button"
                                    onClick={(e) => { this.routeToTransition(props, e) }}
                                    hidden={(props.original.id == undefined) ? true : false}>
                                    Transitions</button><b />


                                {/* Edit/Save Button */}
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}
                                    title={(props.original.id == undefined) ? "Save" :
                                        ((props.original.id != this.state.editedId) ?
                                            "Edit" : "Save")}>

                                    <img className="img-responsive" id="editOrSave"
                                        style={{
                                            marginTop: '8px', backgroundColor: '#282a65',
                                            borderRadius: '5px', padding: '1px'
                                        }}
                                        src={
                                            (props.original.id == undefined)
                                                ?
                                                this.saveImageSrc :

                                                ((props.original.id != this.state.editedId)
                                                    ?
                                                    this.editImageSrc : this.saveImageSrc)}
                                        onClick={(e) => {
                                            (props.original.id == undefined)
                                                ?
                                                this.saveCell(props, e)
                                                :
                                                ((props.original.id == this.state.editedId)
                                                    ?
                                                    this.updateDsmApi(props, e)
                                                    :
                                                    this.editCell(props, e));

                                        }}
                                    />
                                </button>
                                {/* Delete Button*/}
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}
                                    title="Delete" >
                                    <img className="img-responsive" src="./assets/images/baseline_delete_white_24dp.png"
                                        style={{
                                            marginTop: '6px',
                                            backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                        }}
                                        onClick={() => (props.original.id) === undefined ?
                                            this.fetchDsmData() :
                                            this.setState({
                                                hideDeletePopup: true,
                                                propsId: props.original.id
                                            })
                                        }
                                    />
                                </button>
                            </p>
                        </div>
                    </div>

                )
            },
        ]

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>

                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="./assets/css/react-table-height.css" />


                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="col-sm-12" style={{ backgroundColor: '#F9F9FB', marginTop: '-21px ' }}>
                        <div className="row">
                            <div className="col-sm-7">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '25px', marginLeft: '10px'
                                }}>Dialog State Transitions</h6>
                            </div>

                            <div className="d-flex flex-row-reverse pt-2 col-sm-5">
                                {/* Refresh Page */}
                                <button className="btn action-button" title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png" onClick={this.refreshData} />
                                </button>

                                {/* Add Row Button */}
                                <button className="btn action-button" title="Add">
                                    <img src="./assets/images/add_white_24dp.png"
                                        onClick={this.state.disableAdd ? this.notifyEmptyFields : this.addRow} />
                                </button>

                                <Select
                                    value={this.domains.filter(option => option.label === selectedOption)}
                                    onChange={this.handleChange}
                                    options={this.domains} />
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: "21px" }}>
                        <ReactTable
                            data={data}
                            columns={columns}
                            defaultPageSize={10}
                            pageSizeOptions={[5, 10, 15]}
                            onPageChange={this.onPageChange}
                            page={this.state.pageNum}
                            style={{
                                backgroundColor: 'white',
                                marginRight: '12px', marginLeft: '12px'
                            }}
                        /></div>

                    <ToastContainer className="Toast-at-center" />

                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent width='400px' animationSettings={this.settings}
                        header='Async Automata' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete the Async Automata?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                </div>
            </div>
        )
    }
}
export default Dsm;





// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/transition/Dsm.js